export const PREFIX_BUILD_EVENT_NAME = 'anketa-v2-common-customer-';

export const buildEventName = (eventName: string, platform?: string) => {
  if (eventName.startsWith(PREFIX_BUILD_EVENT_NAME)) return eventName;
  return platform ? `${PREFIX_BUILD_EVENT_NAME}${platform}_${eventName}` : `${PREFIX_BUILD_EVENT_NAME}${eventName}`;
};
